import { render, staticRenderFns } from "./How.vue?vue&type=template&id=c678dafa&scoped=true&"
import script from "./How.vue?vue&type=script&lang=js&"
export * from "./How.vue?vue&type=script&lang=js&"
import style0 from "./How.vue?vue&type=style&index=0&id=c678dafa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c678dafa",
  null
  
)

export default component.exports